import "./index.css";
import Button from "../button";
import { useState } from "react";
import { postToLinkedin } from "../../functions/postToLinkedin";

function LinkedinPostModule({ display, close, structure, image, id, voiceId, voiceName, onPostSuccess }) {
  const [buttonText, setButtonText] = useState("Post to LinkedIn");
  const [linkedinPostUrl, setLinkedinPostUrl] = useState(null);

  const handlePost = async () => {
    setButtonText("Posting...");
    try {
      const result = await postToLinkedin(id, voiceId, image);
      setButtonText("Posted!");
      if (result?.linkedinPostUrl) {
        setLinkedinPostUrl(result.linkedinPostUrl);
        onPostSuccess?.(result.linkedinPostUrl);
      }
    } catch (e) {
      setButtonText("Failed — try again");
    }
  };

  const handleClose = () => {
    setButtonText("Post to LinkedIn");
    setExpanded(false);
    close();
  };

  const cleanedStructure = structure ? structure.replace(/\*/g, "") : "";
  const [expanded, setExpanded] = useState(false);
  const previewLimit = 100;
  const needsTruncation = cleanedStructure.length > previewLimit;

  return (
    <div id="linkedin-post-blur-wrapper" style={{ display: display }}>
      <div id="linkedin-post-module">
        <div className="input-module-title-holder">
          <h2 className="big-text">Post to LinkedIn</h2>
          <button className="close-btn" onClick={handleClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          </button>
        </div>

        <div id="linkedin-post-card">
          <div id="linkedin-post-card-header">
            <div id="linkedin-avatar">{voiceName ? voiceName.charAt(0).toUpperCase() : "M"}</div>
            <div id="linkedin-author-info">
              <div id="linkedin-author-name">{voiceName || "Your profile"}</div>
              <div id="linkedin-author-meta">Just now · <img src="./images/linkedin.png" alt="" id="linkedin-meta-icon" /></div>
            </div>
          </div>

          <div id="linkedin-post-body">
            {expanded || !needsTruncation
              ? cleanedStructure
              : cleanedStructure.slice(0, previewLimit) + "..."}
            {needsTruncation && !expanded && (
              <span id="linkedin-see-more" onClick={() => setExpanded(true)}>see more</span>
            )}
          </div>

          {image && (
            <img id="linkedin-post-image" src={image} alt="Post image" />
          )}

          <div id="linkedin-post-reactions">
            <div className="linkedin-reaction-row">
              <span className="linkedin-reaction-icons">👍 ❤️</span>
              <span className="linkedin-reaction-count">Be the first to react</span>
            </div>
          </div>

          <div id="linkedin-post-actions">
            <div className="linkedin-action-item">
              <img src="./images/linkedin.png" alt="" className="linkedin-action-icon" />
              <span>Like</span>
            </div>
            <div className="linkedin-action-item">
              <img src="./images/linkedin.png" alt="" className="linkedin-action-icon" />
              <span>Comment</span>
            </div>
            <div className="linkedin-action-item">
              <img src="./images/linkedin.png" alt="" className="linkedin-action-icon" />
              <span>Repost</span>
            </div>
            <div className="linkedin-action-item">
              <img src="./images/linkedin.png" alt="" className="linkedin-action-icon" />
              <span>Send</span>
            </div>
          </div>
        </div>

        {linkedinPostUrl && (
          <a
            href={linkedinPostUrl}
            target="_blank"
            rel="noreferrer"
            className="view-on-linkedin-link"
          >
            <Button image='./images/linkedin.png' text='View on LinkedIn' smallBool={false} />
          </a>
        )}

        {!linkedinPostUrl && (
          <Button
            image="./images/linkedin.png"
            text={buttonText}
            addedFunction={handlePost}
          />
        )}
      </div>
    </div>
  );
}

export default LinkedinPostModule;
